import type { BottleType } from "../schema";
import { INK, centred, doc, labelWidth, ornament, rect } from "./kit";
import type { LabelTemplate } from "./types";

// Bordeaux château: a double rule frame hugging the label edge, so each
// bottle gets its own layout (a re-bottled frame would no longer sit at an
// even 3 mm inset).
export const chateauClassic: LabelTemplate = {
  key: "chateau-classic",
  name: "Bordeaux château",
  occasion: "classic",
  style: "Bordeaux château",
  description: "A double-ruled frame, a small crest and engraved capitals.",
  hasImageSlot: false,
  build(bottle: BottleType) {
    const W = labelWidth(bottle);
    const cx = W / 2;
    const m = { margin: 8 };
    return doc(bottle, INK["warm-white"], [
      rect(INK.charcoal, { x: 3, y: 3, width: W - 6, height: 94 }, 0.4),
      rect(INK.charcoal, { x: 5, y: 5, width: W - 10, height: 90 }, 0.3),
      ornament("mantled-shield", INK.charcoal, { width: 24, at: [cx, 26] }),
      centred(bottle, { ...m, text: "YOUR ESTATE", font: "cinzel", size: bottle === "wine" ? 6 : 5.4, color: INK.charcoal, baseline: 47.5, tracking: 0.12 }),
      centred(bottle, { ...m, text: "Grand Vin", font: "cormorant", italic: true, size: 3.5, color: INK.burgundy, baseline: 56.5 }),
      ornament("diamond-divider", INK.charcoal, { width: 34, at: [cx, 62.4] }),
      centred(bottle, { ...m, text: "2026", font: "cormorant", size: 4, color: INK.charcoal, baseline: 72, tracking: 0.08 }),
      centred(bottle, { ...m, text: "Cellar-bottled for the occasion", font: "montserrat", size: 1.8, color: INK.charcoal, baseline: 85, tracking: 0.08 }),
    ]);
  },
};
